/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Maintenance from '../../../functions/logic/Maintenance';
import Spiner from '../../../components/Spiner';
//import CreateTable from '../../../components/DataTable';
import FormModal from '../../../components/FormModal';
import ConfirmModal from '../../../components/ConfirmModal';
import { useSnackbar } from 'notistack';

export default function Users() {
    const [spiner, setSpiner] = useState(false);
    const [users, setUsers] = useState([]);
    const [isOpenModalform, setIsOpenModalForm] = useState(false);
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
    const [dataUserForm, setDataUserForm] = useState([]);
    const [accessDataForm, setAccessDataForm] = useState([]);
    const [accessDataUserForm, setAccessDataUserForm] = useState([]);
    const [saveType, setSaveType] = useState('I');
    const [userId, setUserId] = useState(0);
    const [userIdAccess, setUserIdAccess] = useState(0);
    const param = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const userToken = localStorage.getItem('userToken');

    const [isOpenModalAccesform, setIsOpenModalAccessForm] = useState(false);


    useEffect(() => {
        setSpiner(true);
        getUsers(param);
        setSpiner(false);
    }, [param]);

    const getUsers = async (param) => {
        global.MENU_MODULE_SELECT = 'mantenimiento'
        const response = await Maintenance.usersLogic(userToken, param.moduleId);
        localStorage.setItem('param', JSON.stringify(param.moduleId));
        setUsers(response["moduleUsersMapper"]);
        const access = await Maintenance.accessDataLogic(userToken, param.moduleId, 0);
        setAccessDataForm(access[0]);
        setAccessDataUserForm(access[1]);
    }

    const handledNew = async () => {
        cleanStorage();
        setSaveType("I")
        setUserId(0);
        setSpiner(true);
        setDataUserForm([])
        setIsOpenModalForm(true);
        setSpiner(false);
    }

    const handledEdit = async (e) => {
        setSaveType("E")
        setSpiner(true);
        setUserId(e);
        const response = await Maintenance.usersByIdLogic(userToken, param.moduleId, e);
        setDataUserForm(response["moduleMapper"])
        setIsOpenModalForm(true);
        setSpiner(false);
    }

    const handledSave = async (event) => {
        setSpiner(true);
        event.preventDefault();
        const response = await Maintenance.saveUserLogic(userToken, param.moduleId, event.target, userId, saveType);
        setSpiner(false);
        if (!response.error) {
            setIsOpenModalForm(false)
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
            setTimeout(function () {
                getUsers(param);
            }, global.DELAY);
        } else {
            setSpiner(false);
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
    };

    const handledDelete = async (e) => {
        setSpiner(true);
        setUserId(e);
        setIsOpenModalConfirm(true);
        setSpiner(false);
    }

    const handledConfirmDelete = async (e) => {
        setSpiner(true);
        const response = await Maintenance.deleteUserLogic(userToken, param.moduleId, userId);
        setSpiner(false);
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setTimeout(function () {
            getUsers(param);
        }, global.DELAY);
    }

    const handleCloseModal = () => {
        cleanStorage();
        setIsOpenModalForm(false);
        setIsOpenModalConfirm(false);
        setIsOpenModalAccessForm(false);
    };

    const cleanStorage = () => {
        localStorage.removeItem('identification');
        localStorage.removeItem('names');
        localStorage.removeItem('middleNames');
        localStorage.removeItem('direction');
        localStorage.removeItem('phone');
        localStorage.removeItem('cellphone');
        localStorage.removeItem('email');
        localStorage.removeItem('userName');
    }

    const handledSaveAccess = async (event) => {
        setSpiner(true);
        event.preventDefault();
        setSpiner(false);
    };

    const handledEditAccess = async (e) => {
        setSpiner(true);
        const access = await Maintenance.accessDataLogic(userToken, param.moduleId, e);
        setUserIdAccess(e)
        setAccessDataForm(access[0]);
        setAccessDataUserForm(access[1]);
        setIsOpenModalAccessForm(true);
        setSpiner(false);
    };

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={'Editar usuario'}
                button={'Guardar'}
                formData={dataUserForm}
                handledSave={handledSave}
                opt={'users'}
            />

            <FormModal
                isOpen={isOpenModalAccesform}
                handleCloseModal={handleCloseModal}
                header={'Accesos del usuario'}
                formData={accessDataForm}
                handledSave={handledSaveAccess}
                formData2={accessDataUserForm}
                opt={'access'}
                token={userToken}
                userIdAccess={userIdAccess}
                param={param.moduleId}
            />

            <ConfirmModal
                isOpen={isOpenModalConfirm}
                handleCloseModal={handleCloseModal}
                header={'Eliminar usuario'}
                body={'Estás seguro de inactivar al usuario'}
                button={'Eliminar'}
                formData={dataUserForm}
                handledConfirmDelete={handledConfirmDelete}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="project-actions text-right">
                                            <button className="btn btn-primary btn-sm" onClick={handledNew}>
                                                <i className="fas fa-folder"></i> Nuevo usuario
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                           
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >
            </div >
        </>
    )
}




